import { findNestedKey } from "helpers";

WYATT.storeAvailability ||= {};

class StoreAvailability {
  constructor() {
    this.responseKeys = {
      availabilities: WYATT.config.storeAvailability.enhanced
        ? "inventoryLevels"
        : "storeAvailability",
      location: "location",
      quantityAvailable: WYATT.config.storeAvailability.enhanced
        ? "quantity"
        : "quantityAvailable",
    };
    this.promises = {}; // Responses are cached for life of page load. Clear this at a certain time interval??
  }

  async gettingAvailability(variantID) {
    if (!this.promises[variantID]) {
      this.promises[variantID] = this.fetchAvailability(variantID);
    }
    return this.promises[variantID];
  }

  async fetchAvailability(variantID) {
    if (WYATT.config.storeAvailability.enhanced) {
      const response = await fetch(
        `${WYATT.config.storeAvailability.endpoint}${variantID}`,
      );
      const parsedResponse = await response.json();

      return this.getData(parsedResponse);
    }

    const options = {
      method: "post",
      headers: WYATT.config.api.headers,
      body: JSON.stringify({
        query: `{
          node(id: "gid://shopify/ProductVariant/${variantID}") {
            ... on ProductVariant {
              storeAvailability(first: ${WYATT.shopify.stores.length}) {
                edges {
                  node {
                    location {
                      id
                      name
                    }
                    quantityAvailable
                  }
                }
              }
            }
          }
        }`,
      }),
    };

    const response = await fetch(WYATT.config.api.endpoint, options);

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }

    const parsedResponse = await response.json();

    return this.getData(parsedResponse);
  }

  getData(parsedResponse) {
    const data = [];

    const availabilities =
      findNestedKey(parsedResponse, this.responseKeys.availabilities)?.edges ||
      [];

    availabilities.forEach((availability) => {
      const { id, name, localPickupSettingsV2 } = findNestedKey(
        availability,
        this.responseKeys.location,
      );
      const quantityAvailable = findNestedKey(
        availability,
        this.responseKeys.quantityAvailable,
      );

      data.push({
        id: JSON.parse(id.split("/Location/")[1]),
        localPickupSettingsV2,
        name,
        pickUpEnabled: WYATT.config.storeAvailability.enhanced
          ? !!localPickupSettingsV2
          : true,
        quantityAvailable,
      });
    });

    return data;
  }
}

WYATT.storeAvailability = new StoreAvailability();

export default StoreAvailability;
